import { useFocusEffect } from 'expo-router';
import { useCallback, useEffect, useRef } from 'react';
import { AppState } from 'react-native';

export function useRefetchOnRegainFocus(active: boolean, refetch: (() => unknown) | undefined) {
  const activeRef = useRef(active);
  const refetchRef = useRef(refetch);
  const firstFocusRef = useRef(true);

  activeRef.current = active;
  refetchRef.current = refetch;

  const refetchIfActive = useCallback(() => {
    if (activeRef.current) refetchRef.current?.();
  }, []);

  useFocusEffect(
    useCallback(() => {
      if (firstFocusRef.current) {
        firstFocusRef.current = false;
        return;
      }
      refetchIfActive();
    }, [refetchIfActive]),
  );

  useEffect(() => {
    const subscription = AppState.addEventListener('change', (state) => {
      if (state === 'active') refetchIfActive();
    });
    return () => subscription.remove();
  }, [refetchIfActive]);
}
